var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMatchLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_match_light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80078 7.50078C6.80078 7.11418 7.11418 6.80078 7.50078 6.80078H19.1477C19.5343 6.80078 19.8477 7.11418 19.8477 7.50078V12.1287C23.414 12.4787 26.2005 15.4859 26.2005 19.144V19.1506C26.2005 23.0438 23.0442 26.1999 19.1509 26.1999H19.1443C15.486 26.1999 12.4785 23.4134 12.1287 19.8471H7.50078C7.11418 19.8471 6.80078 19.5337 6.80078 19.1471V7.50078ZM13.5373 19.8471C13.8805 22.6385 16.26 24.7998 19.1443 24.7998H19.1509C22.2711 24.7998 24.8005 22.2705 24.8005 19.1506V19.144C24.8005 16.26 22.6391 13.8806 19.8477 13.5373V19.1471C19.8477 19.5337 19.5343 19.8471 19.1477 19.8471H13.5373ZM18.4477 13.5372C15.8845 13.8524 13.8526 15.8842 13.5373 18.4471H18.4477V13.5372ZM18.4477 12.1287C15.1106 12.456 12.4562 15.1102 12.1287 18.4471H8.20078V8.20078H18.4477V12.1287Z",
    fill: "#121619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMatchLight);
export default __webpack_public_path__ + "static/media/icon_match_light.aeed0d66.svg";
export { ForwardRef as ReactComponent };